export default function LogoutIcon({
  color = 'currentColor',
}: {
  color?: string;
}) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.90002 8.56023C10.21 4.96023 12.06 3.49023 16.11 3.49023H16.24C20.71 3.49023 22.5 5.28023 22.5 9.75023V16.2702C22.5 20.7402 20.71 22.5302 16.24 22.5302H16.11C12.09 22.5302 10.24 21.0802 9.91002 17.5402"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13H4.62"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.85 9.6499L3.5 12.9999L6.85 16.3499"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.01"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 25L1 1L25 1L25 25L1 25Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
}
